export enum CheckoutField {
    AgreeWithConditions = 'agreeWithConditions',
    BookerEmail = 'bookerEmail',
    BookerFirstName = 'bookerFirstName',
    BookerLastName = 'bookerLastName',
    BookerTelephone = 'bookerPhone',
    CardCVV = 'cvv',
    CardExpiration = 'expiration',
    CardHolderName = 'holderName',
    CardNumber = 'number',
    Email = 'email',
    FirstName = 'firstName',
    LastName = 'lastName',
    NationalityCode = 'nationalityCode',
    Notes = 'notes',
    Telephone = 'phone',
}
